import Vue from "vue";
import Vuex from "vuex";
import makeCall from "../services/api";

import invoiceModule from "./invoiceModule";
import editSite from './editSite'
import extraData from './extraData'
import searchState from './searchState'

Vue.use(Vuex);

const showLogs = false
const changeWatcher = store => {
  store.subscribe((mutation, state) => {
    showLogs && console.log(mutation, state);
  });
};

const defaultModal = {
  mounted: false,
  compontent: null,
  goodClick: null,
  badClick: false,
  hideGoodClick: false,
  hideBadClick: false,
  header: "",
  props: {}
};

const store = new Vuex.Store({
  state: {
    lastSync: null,
    user: {
      username: null,
    },
    alerts: [],
    customerList: {
      loaded: false,
      data: []
    },
    moduleManager: {
      loaded: false,
      data: {}
    },
    dataLoaded: false,
    isMobile: false,
    sideOpen: false,
    counts: {},
    modal: { ...defaultModal }
  },
  mutations: {
    updateAlertsList(state, payload) {
      localStorage.setItem('alerts', JSON.stringify(payload))
      state.alerts = [...payload]
    },
    updateAllowedModulesList(state, payload) {
      localStorage.setItem('moduleData', JSON.stringify(payload))
      state.moduleManager = {
        data: payload,
        loaded: true
      }
    },
    logOutUser(state){
      this.commit('updatedSearchResults', {})
      localStorage.clear()
      state.user = { username: null }
      state.customerList = { loaded: false, data: []}
      state.counts = {}
      state.moduleManager = {
        loaded: false,
        data: {}
      }
      this.commit('clearInvoiceState')
      this.commit('clearEditSiteState')
      this.commit('clearExtraDataState')
    },
    updateUser(state, payload){
      localStorage.setItem('userData', JSON.stringify(payload))
      state.user = payload
    },
    updateLastSync(state, payload){
      localStorage.setItem('lastSync', payload)
      state.lastSync = payload
    },
    updateIsMobile(state, status) {
      state.isMobile = status;
      if (status === true && state.sideOpen) {
        state.sideOpen = false;
      }
    },
    updateSideOpen(state) {
      state.sideOpen = !state.sideOpen;
    },
    updateCounts(state, counts) {
      localStorage.setItem('counts', JSON.stringify(counts))
      state.counts = counts;
    },
    updateDataLoaded(state) {
      state.dataLoaded = true;
    },
    setModal(state, payload) {
      state.modal = payload
        ? { ...defaultModal, ...payload }
        : { ...defaultModal };
    },
    updateCustomerList(state, payload) {
      localStorage.setItem('customerList', JSON.stringify(payload))
      state.customerList = { data: payload, loaded: true };
    },
  },
  getters: {
    hasInvoiceAccess(state) {
      if (!state.moduleManager.data.accessOnly) return false
      return [...state.moduleManager.data.accessOnly]
      .reduce((status, module) => {
        if (module.name ==='Invoices') {
          return module.active
        } return status
      }, false)
    },
    alerts(state) {
      return state.alerts
    },
    customerList(state) {
      return state.customerList;
    },
    moduleManager(state) {
      return state.moduleManager
    },
    user(state) {
      return state.user;
    },
    isMobile(state) {
      return state.isMobile;
    },
    sideOpen(state) {
      return state.isMobile === false || state.sideOpen;
    },
    counts(state) {
      return state.counts;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    modal(state) {
      return state.modal;
    }
  },
  actions: {
    updateUserData: async({commit}, payload) => {
      commit('updateUser', payload)
      try {
        const result = await makeCall({
          url: `/userdata/`,
          body: payload,
          method: 'PATCH'
        }, commit);
        return { success: result && result.success }
      } catch (e) {
        return { success: false }
      }

    },
    userLogin: async({commit, dispatch}, payload) => {
      const { username, password } = payload
      const result = await makeCall({
        fullUrl: '/api/token/',
        body: { username: 'a1_' + username, password },
        method: 'POST',
        refresh: true,
      }, ()=>{ })
      if(result && result.access && result.refresh){
        localStorage.setItem('access', result.access)
        localStorage.setItem('refresh', result.refresh)
        commit('updateUser', {username})
        dispatch("loadData")
        return 'success'
      } else {
        return 'error'
      }
    },
    loadData: async ({ state, commit }) => {
      let hasLocalData = false
      const lastSync = localStorage.getItem('lastSync')
      const localInvoiceList = localStorage.getItem('invoiceList')
      const userData = localStorage.getItem('userData')
      const localCounts = localStorage.getItem('counts')
      const searchResults = localStorage.getItem("searchResults")
      const localAlerts = localStorage.getItem("alerts")

      if(userData && localInvoiceList && localCounts){
        const inv = JSON.parse(localInvoiceList)
        const alerts = localAlerts ? JSON.parse(localAlerts) : []
        const cou = JSON.parse(localCounts)
        const usr = JSON.parse(userData)
        const sr = JSON.parse(searchResults)
        hasLocalData = true
        commit("updateAlertsList", alerts)
        commit("updateInvoiceList", inv);
        commit("updateInvoicePage", 1);
        commit("updateCounts", cou);
        commit("updateUser", usr)
        commit("updateDataLoaded");
        commit("updatedSearchResults", sr)
      }

      let shouldUpdate = false // checktimestamp
      if(lastSync){
        const hoursSinceLastSync = (new Date - new Date(lastSync)) / 3600000
        if(hoursSinceLastSync > 15) {
          shouldUpdate = true
        } else {
          commit('updateLastSync', lastSync)
          const pingTest = await makeCall({url: `/ping/${lastSync}/`}, commit)
          if(pingTest && pingTest.update){
            shouldUpdate = true
          }
        }
      } else shouldUpdate = true

      if(!hasLocalData || shouldUpdate){
        const data = await makeCall({ url: `/userdata/${state.user.username}/` }, commit);
        commit("updateInvoiceList", data.invoiceList);
        commit("updateInvoicePage", 1);
        const dueTodayAlerts = data.dueToday
          ? [...data.dueToday].map(dueItem => ({
            status: 'neutral',
            dismissed: false,
            message: `Order ${dueItem.invoice} due today ${dueItem.business && dueItem.business !== '' ? `for ${dueItem.business}` : ''}`,
            route: `newinvoice/edit/${dueItem.invoice}`
          })) : []
        commit("updateAlertsList", dueTodayAlerts)
        commit("updateCounts", data.counts);
        commit('updateLastSync', data.lastSync)
        commit('updateUser', {username: state.user.username, ...data.userData})
        commit("updateDataLoaded");
      }
    },
    deleteModule:  async ({state, commit, dispatch}, moduleId) => {
      await makeCall({url: `/modules/${state.user.username}/${moduleId}/`, method: 'DELETE'}, commit)
      return dispatch('updateAllowedModulesList', true)
    },
    saveModule:  async ({state, commit, dispatch}, payload) => {
      const body = {
        ...payload,
        adminOnly: payload.parent === 'Admin',
        action: 'save'
      }
      const method = body.id ? 'PATCH' : 'POST'
      await makeCall({url: `/modules/${state.user.username}/`, method, body}, commit)
      return dispatch('updateAllowedModulesList', true)
    },
    updateAllowedModulesList: async ({state, commit}, refresh = false) => {
      const localModuleData = localStorage.getItem('moduleData')
      let moduleData
      if (!refresh && localModuleData) {
        moduleData = JSON.parse(localModuleData)
      } else {
        if (!state.user.username) return null
        const response = await makeCall({url: `/modules/${state.user.username}/`})
        const { data } = response
        moduleData = data.reduce((pre, cur) => {
          if(cur.parent) {
            if (pre[cur.parent]) {
              pre[cur.parent].push(cur)
            } else {
              pre[cur.parent] = [cur]
            }
          } else {
            pre.accessOnly.push(cur)
          }
          return pre
        }, { accessOnly: [] })
      }
      commit('updateAllowedModulesList', moduleData)
    },
    updateDisplayedModulesList: async({state}, payload) => {
      const promises = []
      Object.values(payload.changes).forEach(async change => {
        const postItem = {
          moduleId: change.id,
          action: 'disable'
        }
        if (change.disabled_record_id) {
          postItem.recordId = change.disabled_record_id
          postItem.action = 'enable'
        }
        promises.push(makeCall({ method: 'POST', body: postItem, url: `/modules/${state.user.username}/` }))
      })
      return Promise.all(promises)
        .then(resp => resp)
    },
    loadCustomerList: async ({commit}) => {
      let hasLocalData = false
      const localCustomerList = localStorage.getItem('customerList')
      if(localCustomerList){
        const data = JSON.parse(localCustomerList)
        if(Array.isArray(data) && data.length > 0) {
          hasLocalData = true
          commit('updateCustomerList', data)
        }
      }
      if(!hasLocalData){
        const data = await makeCall({ url: "/customers/" }, commit);
        commit('updateCustomerList', data.customerList)
      }
    }
  },
  modules: { invoiceModule, editSite, extraData, searchState },
  plugins: [changeWatcher]
});

export default store;
